import { type Fandom } from "@prisma/client";
import { Avatar } from "antd";
import Link from "next/link";
import SVGAtom from "~/components/Atoms/SVGAtom/SVGAtom";

type Props = {
  fandom: Fandom[];
};

export const FandomJoinedListModule = (props: Props) => {
  return (
    <div className="flex flex-row items-start justify-start gap-[16px] overflow-x-auto bg-white p-[10px_24px_20px_20px]">
      {props.fandom.length > 0 ? (
        props.fandom.map((fandom, index) => (
          <div key={fandom.id}>
            <Link key={`${(fandom.id, index)}`} href={`/fandom/${fandom.id}`}>
              <div className="flex flex-col items-center gap-[10px]">
                <Avatar src={fandom.imageUrl} size={80} />
                <div className="flex max-h-[32px] w-[80px] items-center justify-center">
                  <span className="multi-line-truncate h-fit max-w-full overflow-visible whitespace-pre-wrap break-words text-center text-[13px] font-medium leading-[16px]">
                    {fandom.title}
                  </span>
                </div>
              </div>
            </Link>
          </div>
        ))
      ) : (
        <Link scroll={false} href={"/joinFandom"}>
          <div className="flex flex-col items-center gap-[10px]">
            <div className="flex h-[80px] w-[80px] items-center justify-center rounded-full bg-[#f0f0f0]">
              <SVGAtom iconName="plus" width={22} height={22} color="#bfbfbf" />
            </div>
            <span className="w-[80px] text-center text-[13px] font-medium leading-[15.73px]">
              Add Fandom
            </span>
          </div>
        </Link>
      )}
    </div>
  );
};
